
import CardMarker from '../../components/CockpitCards/CardMarker';
import GetRecords from './GetRecords';

export default function SectionRecordCard(data) {


return (
<>
<CardMarker

headline="INCIDENTS HISTORY & ARCHIVE"
subtext={"In this section you find all your incidents chronologically ordered. When you click on the RECORDS icon all archived diagnostic reports and exam images are presented. Add new incidents by clicking on the ADD icon. Be aware that you see the new incident added when the page is rendered the next time. "}  
cardlines = {<>      

      <GetRecords />

     </>}   
   />    
 </>
)};
  